<template>
  <div id="disqus_thread"></div>
</template>

<script>
export default {
  name: "DisqusThread",
  props: {
    identifier: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },
  mounted() {
    if (window.DISQUS) {
      this.resetDisqus();
    } else {
      this.initDisqus();
    }
  },
  watch: {
    identifier() {
      this.resetDisqus();
    },
  },
  methods: {
    initDisqus() {
      const self = this;
      window.disqus_config = function () {
        this.page.url = self.url;
        this.page.identifier = self.identifier;
      };

      const d = document;
      const s = d.createElement("script");
      s.src = "https://https-origami-skin-com.disqus.com/embed.js";
      s.setAttribute("data-timestamp", +new Date());
      (d.head || d.body).appendChild(s);
    },
    resetDisqus() {
      if (window.DISQUS) {
        const self = this;
        window.DISQUS.reset({
          reload: true,
          config: function () {
            this.page.identifier = self.identifier;
            this.page.url = self.url;
          },
        });
      }
    },
  },
};
</script>
